import { fundsOrderResumeData } from './types';

interface FundsTableTemplateProps {
  data: fundsOrderResumeData[];
  assetCount: number;
  totalValue: string;
}

export const fundsTableTemplate = ({ assetCount, data, totalValue }: FundsTableTemplateProps) => {
  if (assetCount === 0) {
    return '';
  }

  return `
      <div class="product-card">
        <strong class="product-type-title">FUNDOS</strong>
        <div class="product-info">
          <span class="product-info-text">${assetCount} Ativo(s)</span>
          <span class="product-info-text">Total ${totalValue}</span>
        </div>
      </div>
      <div class="product-table">
        <div class="highlight-bar funds"></div>
        <div class="product-table-content">
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">ativo</th>
                <th style="width: 30px;">risco</th>
                <th style="width: 40px;">rent. 12 meses</th>
                <th style="width: 60px;">tax. admin.</th>
                <th style="width: 70px;">resgate e liquidação</th>
                <th style="width: 40px;">valor</th>
              </tr>
            </thead>
            <tbody>
             ${data.map((item) => {
               return `<tr>
               <td>${item.productDisplay}</td>
               <td>${item.riskRating}</td>
               <td>${item.profitabilityTwelveMonths}</td>
               <td>${item.adminTax}</td>
               <td>${item.investmentRedemption}</td>
               <td>${item.valueAppliedFormatted}</td>
             </tr>`;
             })}
            </tbody>
          </table>
        </div>
      </div>
      `;
};
